import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { setGameHomeSpread } from "../../api/api";

export function SetSpreadModal(props) {
    const [homeSpread, setHomeSpread] = useState(null);

    const handleSubmit = (event) => {
        event.preventDefault();

        setGameHomeSpread(props.game, homeSpread).then((games) => {
            props.refreshGames(games);
        }).finally(() => {
            props.setShow(false);
        });
    };

    if (!props.game) {
        return <></>
    }

    return (
        <Modal show={props.show} onHide={() => props.setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Set Home Spread</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="setHomeSpreadForm.HomeSpread">
                        <Form.Label>{props.game.home_team} Spread</Form.Label>
                        <Form.Control type="text" onChange={(e) => setHomeSpread(parseInt(e.target.value))} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="ms-auto" onClick={() => props.setShow(false)}>Cancel</Button>
                    <Button variant="primary" type="submit" onClick={handleSubmit}>Set Home Spread</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
